import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
  fieldArrayButtons: {
    padding: "0",
    marginTop: "16px",
    minWidth: "28px",
    maxWidth: "28px"
  },
  fieldArrayButtonsDiv: {
    display: "flex",
    flexDirection: "row",
    width: "64px",
    justifyContent: "space-between"
  },
  tableHeader: {
    fontFamily: 'EncodeSansRegular',
    fontSize: "18px",
    lineHeight: "1"
  },
  errorMessage: {
    color: "red",
    fontSize: "12px",
    textAlign: "center",
    marginTop: "4px"
  },
  iconCircle: {
    clipPath: "circle(25px at 50% 50%)",
    background:"#bb0d66",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "-50px",
    height: "50px"
  },
  clientRow: {
    alignItems: 'center',
  },
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
  },
  centerText: {
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttons: {
    display: 'flex',
    flexDirection:"row",
    justifyContent: 'center'
  },
  alert: {
    backgroundColor: theme.palette.warning.dark
  },
  buttonBack: {
    borderRadius:"30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#9A9A9A",
    marginLeft: "5px",
    marginRight: "5px",
    marginTop:"20px",
    border: "solid #BB0D66 0px",
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  buttonContained: {
    borderRadius:"30px",
    color:"#fff",
    fontSize: "16px",
    backgroundColor: "#BB0D66",
    marginLeft: "5px",
    marginRight: "5px",
    marginTop:"20px",
    border: "solid #BB0D66 0px",
    '&:hover': {
      backgroundColor: "#000000",
    },
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%'
  },
}));